module.exports = __webpack_public_path__ + "static/media/190x190px_minainstrument.e1fb19c3.png";